import { Platform, useWindowDimensions } from 'react-native';
import { useAppStore } from '../store/appStore';
import SearchInput from './SearchInput';

const DESKTOP_BREAKPOINT = 768;

export default function SearchBar() {
  const cardInputType = useAppStore((s) => s.cardInputType);
  const { width } = useWindowDimensions();
  const isDesktop = width > DESKTOP_BREAKPOINT;

  if (Platform.OS !== 'web' || cardInputType !== 'search' || !isDesktop) return null;

  return <SearchInput />;
}
